var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, makeObservable, observable, runInAction } from 'mobx';
import log from 'loglevel';
import { CancelToken, isCanceled } from '../cancel';
export class RemoteDataStore {
    constructor() {
        Object.defineProperty(this, "_finishedInitialLoad", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "currentRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "cancelTokenSource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        makeObservable(this, {
            _finishedInitialLoad: observable,
            _error: observable,
            currentRequest: observable,
            load: action,
            createRequest: action,
            handleError: action,
            reset: action,
        });
    }
    get isLoading() {
        return this.currentRequest !== undefined;
    }
    get finishedInitialLoad() {
        return this._finishedInitialLoad;
    }
    get error() {
        return this._error;
    }
    load(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentRequest) {
                yield this.cancelCurrentRequest();
            }
            runInAction(() => {
                this.clear();
                this._error = undefined;
                this.currentRequest = this.createRequest(params);
            });
            return this.currentRequest;
        });
    }
    createRequest(params) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug('Create request');
            this.cancelTokenSource = CancelToken.source();
            const options = {
                cancelToken: this.cancelTokenSource.token,
            };
            let response;
            let canceled = false;
            try {
                const maybeResponse = yield this.performRequest(params, options);
                response = this.validateResponse(maybeResponse);
            }
            catch (e) {
                // Canceled requests are not handled as errors
                if (!isCanceled(e)) {
                    this.handleError(e);
                }
                else {
                    canceled = true;
                }
            }
            if (response !== undefined) {
                this.handleResponse(response);
            }
            if (!canceled) {
                runInAction(() => {
                    this._finishedInitialLoad = true;
                });
            }
            runInAction(() => {
                this.cancelTokenSource = undefined;
                this.currentRequest = undefined;
            });
        });
    }
    validateResponse(response) {
        return response;
    }
    handleError(error) {
        this._error = error instanceof Error ? error : new Error(`${error}`);
    }
    cancelCurrentRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cancelTokenSource) {
                return;
            }
            this.cancelTokenSource.cancel('Request canceled');
            yield this.currentRequest;
        });
    }
    reset() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentRequest) {
                yield this.cancelCurrentRequest();
            }
            this.clear();
            runInAction(() => {
                this._error = undefined;
                this._finishedInitialLoad = false;
            });
        });
    }
}
//# sourceMappingURL=RemoteDataStore.js.map